<template>
  <div class="jps-org-footer">
    <div class="jof-card jof-provider" v-if="providerId">
      <h3 class="jps-section-title generated-4">
        {{ ls(dapLangGlobal.provider) }}
      </h3>
      <UiOrgProviderSpan tag="div" :id="providerId">
        <template v-slot="{ org }">
          <BaseLink :to="orgTo(org)" :nolink="org.type === 'TEMPORARY'">
            <UiImageSelection
              :image="org.image"
              type="organization"
              :cover-override="false"
              background="transparent"
              :appearance="{
                borderRadius: 'small',
              }"
              image-usage="thumbnail"
            />
          </BaseLink>
          <h4 class="jps-h4 has-text-weight-bold generated-4">
            <template v-if="org.type === 'TEMPORARY'">
              <BaseLink :to="providerLink" :nolink="!providerLink">{{
                ls(org.name)
              }}</BaseLink>
            </template>
            <template v-else>
              <BaseLink :to="orgTo(org)">{{ ls(org.name) }}</BaseLink>
            </template>
          </h4>
          <p class="is-size-8">{{ ls(org.description) }}</p>
        </template>
      </UiOrgProviderSpan>
    </div>
    <div class="jof-card jof-aggregator" v-if="providerId !== orgId">
      <h3 v-if="providerId" class="jps-section-title generated-4">
        {{ ls({ ja: 'つなぎ役機関', en: 'Aggregator' }) }}
      </h3>
      <h3 v-else class="jps-section-title generated-4">
        {{ ls({ ja: '連携機関', en: 'Partner' }) }}
      </h3>
      <UiOrgSpan :id="orgId" tag="div">
        <template v-slot="{ org }">
          <BaseLink :to="orgTo(org)">
            <UiImageSelection
              :image="org.image"
              type="organization"
              :cover-override="false"
              background="transparent"
              :appearance="{
                borderRadius: 'small',
              }"
              image-usage="thumbnail"
            />
          </BaseLink>
          <h3
            class="is-size-6 is-size-6-touch has-text-weight-bold generated-4"
          >
            <template v-if="org.type === 'TEMPORARY'">
              <BaseLink :to="providerLink" :nolink="!providerLink">{{
                ls(org.name)
              }}</BaseLink>
            </template>
            <template v-else>
              <BaseLink :to="orgTo(org)">{{ ls(org.name) }}</BaseLink>
            </template>
          </h3>
          <p class="is-size-8">{{ ls(org.description) }}</p>
        </template>
      </UiOrgSpan>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

const { ls } = useI18n()

interface Props {
  providerId?: string
  providerLink?: string
  orgId: string
}
const props = withDefaults(defineProps<Props>(), {
})
</script>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

.jps-org-footer {
  display: flex;
  > * {
    width: 100%;
    padding: 1.25rem;
    p {
      margin-top: 0.75rem;
      color: $jps-gray-800;
    }
    &:nth-child(2) {
      @include is-tablet {
        border-left: 1px solid $jps-gray-300;
      }
    }
  }

  .jps-section-title {
    margin-bottom: 0.75rem;
  }

  flex-direction: column;
  .jof-provider {
    border-bottom: 1px solid $jps-gray-300;
    border-collapse: separate;
    padding: calc(0.25rem * 8);
    padding-top: 0;
    @include is-tablet {
      border-bottom: none;
    }
  }
  .jof-aggregator {
    padding-top: 2rem;
    @include is-tablet {
      padding-top: 0;
    }
  }


  .jps-image-selection {
    height: 6rem !important;
    margin-bottom: 0.5rem;
  }
  @include is-tablet {
    flex-direction: row;
  }
}
</style>

<style lang="scss" scoped>
.generated-4 {
  text-align: center;
}
</style>
